import { VisuallyHidden } from '@s-group/design-system-components/VisuallyHidden/VisuallyHidden'
import { MouseEvent } from 'react'
import { styled } from 'styled-components'

import { Colors } from '../../global/colors'
import { splitStringInHalf } from '../../utilities/helpers'

const RIGHT_TO_LEFT_THRESHOLD = 3

const TitleText = styled.div``

const TruncatedSpan = styled.span<{ $isLink: boolean; $isValid: boolean; $isLongText: boolean }>`
  &:after,
  &:before {
    display: inline-block;
    max-width: 50%;
    overflow: hidden;
    white-space: pre;
    box-shadow: ${(props) => (props.$isLink ? `inset 0 -2px 0 currentColor` : `unset`)};
    cursor: ${(props) => (props.$isLink ? 'pointer' : 'default')};
    color: ${(props) => (props.$isValid ? `${Colors.TextStrongPrimary}` : `${Colors.TextStrongNeutral}`)};
  }

  &:before {
    content: attr(data-content-start);
    text-overflow: clip;
  }

  &:after {
    content: attr(data-content-end);
    text-overflow: ellipsis;
    direction: ${(props) => (props.$isLongText ? 'rtl' : 'unset')};
  }
`

export const TruncatedInMiddleSpan = ({
  text,
  isValid,
  isLink = false,
  isLinkAriaLabel,
  tabIndex,
  onClick,
}: {
  text: string
  isValid: boolean
  isLink?: boolean
  isLinkAriaLabel?: string
  tabIndex: number
  onClick: ((e: MouseEvent<HTMLButtonElement>) => void) | undefined
}) => {
  const splitResult = splitStringInHalf(text)
  return (
    <TitleText>
      <TruncatedSpan
        //TODO: DIG-7517  as="button" so test can target this as button again
        role="button"
        tabIndex={tabIndex}
        data-content-start={splitResult.firstHalf}
        data-content-end={splitResult.secondHalf}
        title={text}
        onClick={onClick}
        $isLink={isLink}
        $isValid={isValid}
        $isLongText={splitResult.firstHalf.length > RIGHT_TO_LEFT_THRESHOLD}
        onMouseDown={(e) => {
          e.currentTarget.style.opacity = '0.7'
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.opacity = '1'
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.currentTarget.style.opacity = '0.7'
            // @ts-expect-error eventType is keyboard and not mouse
            onClick(e)
          }
        }}
        onKeyUp={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.currentTarget.style.opacity = '1'
          }
        }}
      />
      <VisuallyHidden>{isLinkAriaLabel || text}</VisuallyHidden>
    </TitleText>
  )
}
